import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M0 10C0 4.47692 4.47692 0 10 0C15.5231 0 20 4.47692 20 10C20 15.5231 15.5231 20 10 20C4.47692 20 0 15.5231 0 10ZM6.92308 6.15385C6.71906 6.15385 6.52341 6.23489 6.37915 6.37915C6.23489 6.52341 6.15385 6.71906 6.15385 6.92308V13.0769C6.15385 13.5015 6.49846 13.8462 6.92308 13.8462H7.69231C7.89632 13.8462 8.09198 13.7651 8.23624 13.6209C8.38049 13.4766 8.46154 13.2809 8.46154 13.0769V6.92308C8.46154 6.71906 8.38049 6.52341 8.23624 6.37915C8.09198 6.23489 7.89632 6.15385 7.69231 6.15385H6.92308ZM12.3077 6.15385C12.1037 6.15385 11.908 6.23489 11.7638 6.37915C11.6195 6.52341 11.5385 6.71906 11.5385 6.92308V13.0769C11.5385 13.5015 11.8831 13.8462 12.3077 13.8462H13.0769C13.2809 13.8462 13.4766 13.7651 13.6209 13.6209C13.7651 13.4766 13.8462 13.2809 13.8462 13.0769V6.92308C13.8462 6.71906 13.7651 6.52341 13.6209 6.37915C13.4766 6.23489 13.2809 6.15385 13.0769 6.15385H12.3077Z",
      "clip-rule": "evenodd"
    })
  ]))
}